import { defineStore } from 'pinia'

export const useOrderStore = defineStore('order', {
  persist: true,
  state: () => ({
    order_no: '',
    state: 0,
    customer: {
      name: '',
      mobile: '',
      address: '',
      service_date: '',
      service_time: '',
      install_position: '',
      service_category_id: 0,
      service_id: 0,
      additional_requirements: [] as string[],
      remarks: '',
      install_position_image: [] as string[],
      wall_category: '',
      master_images: [] as string[],
      electricity_meter_images: [] as string[],
      environment_images: [] as string[],
      video: ''
    }
  }),
  actions: {
    reset() {
      this.$reset()
    },
    fillFromOrderDetail(order: any) {
      this.order_no = order.order_no || ''
      this.state = order.state || 0
      if (order.customer) {
        Object.assign(this.customer, {
          name: order.customer.name || '',
          state: order.state || 0,
          mobile: order.customer.mobile || '',
          address: order.customer.address || '',
          service_date: order.customer.service_date || '',
          service_time: order.customer.service_time || '',
          install_position: order.customer.install_position || '',
          service_category_id: order.customer.service_category_id || null,
          service_id: order.customer.service_id || null,
          additional_requirements: order.customer.additional_requirements || [],
          remarks: order.customer.remarks || '',
          install_position_image: order.customer.install_position_image || [],
          wall_category: order.customer.wall_category || '',
          master_images: order.customer.master_images || [],
          electricity_meter_images: order.customer.electricity_meter_images || [],
          environment_images: order.customer.environment_images || [],
          video: order.customer.video || ''
        })
      }
    }
  }
}) 